import { CheckIcon, XIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

export interface PricingFeatureProps {
  title: string
  included: boolean
  features?: string[]
}

export const PricingFeature = ({ title, included, features }: PricingFeatureProps) => {
  return (
    <div className={cn('flex flex-col items-start')}>
      <div className={cn('flex')}>
        <div
          className={cn('mr-2.5', {
            'text-primary': included,
            'text-muted-foreground': !included,
          })}
        >
          {included ? <CheckIcon size={24} /> : <XIcon size={24} />}
        </div>
        <div className={cn('text-[18px] font-semibold leading-[28px] text-primary')}>{title}</div>
      </div>
      {features && features.length > 0 && (
        <ul className={cn('list-outside list-disc', 'ml-[38px] mt-[10px]')}>
          {features?.map((feature, index) => (
            <li key={index} className={cn('text-[13px] font-medium leading-[20px] text-zinc-600')}>
              {feature}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
